// extracted by mini-css-extract-plugin
export default {"driversBtns":"DriverManageRidePanel_driversBtns__LhJDs","cancelRideBtn":"DriverManageRidePanel_cancelRideBtn__Y8AOR","arrivalBtn":"DriverManageRidePanel_arrivalBtn__fTDU8"};